import React, { useState } from 'react'
import cn from 'classnames'

import styles from './styles.module.css'
import { useIntl } from 'react-intl'
import Input from '../Input'
import { Eye } from 'src/comps/Atom/Inputs/Input/Password/eye'

interface IPasswordInput {
  readonly label: string
  readonly value: string
  readonly onChange: (value: string) => void
  readonly errors?: string[]
  readonly showHint?: boolean
  readonly dataTestId?: string
}

export function PasswordInput(props: IPasswordInput) {
  const {
    label,
    value,
    onChange,
    errors = [],
    showHint = true,
    dataTestId = 'password-field',
  } = props
  const intl = useIntl()
  const [showPassword, setShowPassword] = useState(false)

  return (
    <>
      <div className={cn(styles.container, { [styles.error]: errors.length > 0 })}>
        <Input
          label={label}
          name="password"
          type={showPassword ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          dataTestId={dataTestId}
          errors={errors}
        />
        <button
          className={styles.showButton}
          type="button"
          onClick={() => setShowPassword(!showPassword)}
        >
          <Eye size={24} lineThrough={showPassword} />
        </button>
      </div>
      {!errors.length && showHint && (
        <span data-testid="password-info" className={styles.hint}>
          {intl.formatMessage({ id: 'global.password-length' })}
        </span>
      )}
    </>
  )
}
